export enum ErrorKey {
  UserNotActive = 'userNotActive',
  UserAlreadyExists = 'userAlreadyExists',
  UserAlreadyActive = 'userAlreadyActive',
  UserRegistrationEmailFailed = 'userRegistrationEmailFailed',
  UserActivationEmailFailed = 'userActivationEmailFailed',
  UserResetPasswordEmailFailed = 'userResetPasswordEmailFailed',

  InvalidCredentials = 'invalidCredentials',
  InvalidToken = 'invalidToken',
  ExpiredToken = 'expiredToken',

  HttpException = 'httpException',
  InternalServerError = 'internalServerError',
  UnknownError = 'unknownError',

  EmailDeliveryFailed = 'emailDeliveryFailed',

  ForeignKeyViolation = 'foreignKeyViolation',
  EntityAlreadyExists = 'entityAlreadyExists',
  RecordNotFound = 'recordNotFound',
}
